import { Theme, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

import AtomDivider from '../../../../components/atoms/AtomDivider';
import AtomGrid from '../../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../../components/resources/styleConfigs';
import TabsWrapper from '../../../../components/wrappers/TabsWrapper';
import TabWrapper from '../../../../components/wrappers/TabWrapper';
import palette from '../../../../theme/learnerPalette';

export const ProfileNavbarContainerStyled = styled(AtomGrid)(() => ({
  [useTheme().breakpoints.down('lg')]: {
    marginBottom: `${styleConfigs.marginPadding.custom170}px !important`,
  },
}));

export const ProfileTabsStyled = styled(TabsWrapper)(({ theme }: { theme: Theme }) => ({
  minHeight: styleConfigs.dimensions.height36,
  marginBottom: styleConfigs.marginPadding.custom32,
  boxShadow: `inset 0 -1px 0 ${theme.palette.divider}`,
  '& .MuiTabs-indicator': {
    bottom: 0,
    zIndex: 1,
  },
  '& .MuiTabs-scroller': {
    height: styleConfigs.dimensions.height36,
  },
}));

export const DividerStyled = styled(AtomDivider)(() => ({
  marginBottom: styleConfigs.marginPadding.custom32,
  [useTheme().breakpoints.down('sm')]: {
    marginBottom: styleConfigs.marginPadding.custom26,
  },
}));

export const ProfileTabStyled = styled(TabWrapper)(({ theme }: { theme: Theme }) => ({
  minWidth: styleConfigs.dimensions.auto,
  minHeight: styleConfigs.dimensions.height36,
  padding: styleConfigs.marginPadding.custom0px,
  marginRight: `${styleConfigs.marginPadding.custom24}px`,
  fontWeight: styleConfigs.fonts.weight500,
  '&.Mui-selected': {
    fontWeight: styleConfigs.fonts.bold,
  },
  fontSize: styleConfigs.fonts.fontSize20,
  color: palette.light.text.mistBlue,
  [theme.breakpoints.down('md')]: {
    fontSize: styleConfigs.fonts.fontSize18,
    marginRight: `${styleConfigs.marginPadding.custom25}px !important`,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.fontSize14,
    marginRight: `${styleConfigs.marginPadding.custom16}px !important`,
  },
  '&:last-of-type': {
    marginRight: styleConfigs.marginPadding.custom0px,
  },
}));
